import { Link } from 'react-router-dom';
import RenovationScene from './RenovationScene';

export default function Hero() {
  return (
    <header>
      <RenovationScene />
      <div className="max-w-6xl mx-auto px-6 pt-8 pb-24 sm:pt-10">
        <h1 className="text-5xl sm:text-6xl lg:text-7xl leading-[1.04] tracking-tight">
          <span className="block font-extrabold text-[#141414]">Tu inmobiliaria,</span>
          <span className="block italic font-semibold text-[#8A8578]">en orden y con datos.</span>
        </h1>
        <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-[#141414]/75">
          Promociona propiedades, da seguimiento a tus prospectos y administra tus{' '}
          <strong>rentas</strong> en un solo lugar. La plataforma que el mercado inmobiliario usa
          para decidir con datos, no con intuición.
        </p>
        <div className="mt-10 flex items-center gap-6">
          <Link
            to="/register"
            className="bg-[#141414] text-white text-sm font-semibold rounded-full px-8 py-4 shadow-[0_24px_60px_-30px_rgba(20,20,20,0.55)] hover:scale-[1.02] transition-transform"
          >
            Comenzar
          </Link>
          <a
            href="#contacto"
            className="text-sm font-semibold text-[#141414] underline underline-offset-4 decoration-[#141414]/30 hover:decoration-[#141414]"
          >
            Contáctanos
          </a>
        </div>
        <p className="mt-10 text-[11px] font-semibold tracking-[0.25em] text-[#8A8578] uppercase">
          Sin hojas de cálculo · Sin prospectos perdidos · Sin cobros olvidados
        </p>
      </div>
    </header>
  );
}
